<div class="site-map">
  <div #mapTarget class="site-map__target" [hidden]="store.viewMode() === '3d'"></div>
  <div #map3dTarget class="site-map__target site-map__target--3d" [hidden]="store.viewMode() !== '3d'"></div>
  @if (map3dLoading()) {
    <div class="map-3d-loading">{{ 'GLOBAL.CHARGEMENT' | translate }}</div>
  }

  @if (store.viewMode() !== '3d') {
  <div class="bottom-right-widgets">
    <app-site-map-hole-legend />
    <div class="mouse-position">
      <span>{{ coordinates().projection }}<br />{{ coordinates().xLabel }}: {{ coordinates().x }}<br />{{ coordinates().yLabel }}: {{ coordinates().y }}</span>
    </div>
  </div>

  <div class="custom-zoom">
    <button type="button" title="Zoom in" (click)="zoomBy(1)">
      <img src="assets/icon/Zoom+.svg" alt="" />
    </button>
    <button type="button" title="Zoom out" (click)="zoomBy(-1)">
      <img src="assets/icon/Zoom-.svg" alt="" />
    </button>
  </div>

  <div class="custom-scale-line">
    <span>{{ scaleLabel() }}</span>
    <div class="scale-bar" [style.width.px]="scaleWidth()"></div>
  </div>
  }

  <div class="top-right-buttons">
    <button type="button" class="icon-carto" [class.active]="store.viewMode() === 'map2d'" (click)="setViewMode('map2d')">
      <img src="assets/icon/map.svg" alt="" />
      <div class="btn-label">Map</div>
    </button>
    <button type="button" class="icon-carto" [class.active]="store.viewMode() === 'plan2d'" (click)="setViewMode('plan2d')">
      <img src="assets/icon/Flat_map.svg" alt="" />
      <div class="btn-label">Plan</div>
    </button>
    <button type="button" class="icon-carto" [class.active]="store.viewMode() === '3d'" (click)="setViewMode('3d')">
      <img src="assets/icon/3D.svg" alt="" />
      <div class="btn-label">3D</div>
    </button>
  </div>

  @if (store.viewMode() !== '3d') {
    <app-site-map-right-menu />
  }
  <app-site-map-draw-dialog />

  @switch (store.activePanel()) {
    @case ('kpi') { <app-site-map-kpi-panel /> }
    @case ('holes') { <app-site-map-holes-panel /> }
    @case ('equipment') { <app-site-map-equipment-panel /> }
    @case ('orthophotos') { <app-site-map-layers-panel kind="orthophotos" /> }
    @case ('dxf') { <app-site-map-layers-panel kind="dxf" /> }
    @case ('filter') { <app-site-map-filter-panel /> }
  }

  <div #popupElement class="map-popup" [hidden]="!store.popup()" [style.--popup-max-height]="popupMaxHeight() ? popupMaxHeight() + 'px' : null">
    @if (store.popup(); as popup) {
      <app-site-map-popup [popup]="popup" [showDetailsLink]="showDetailsLink()" (openBlast)="openBlast.emit($event)" />
    }
  </div>

  @if (tooltip(); as tip) {
    <div class="map-tooltip" [style.left.px]="tip.x" [style.top.px]="tip.y">{{ tip.text }}</div>
  }
</div>
